import { DiscountScale } from '@photosi/expo-photosi-sdk/build/Project';
import { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

export const useDiscountTableLogic = (discount: DiscountScale[], progress: number, isMobile?: boolean) => {
  const anyMilestoneShowingCheckSV = useSharedValue(false);
  const { isSmallDesktop } = useResponsiveScreen();

  const titleTextReachedAnimatedStyle = useAnimatedStyle(() => {
    return {
      opacity: withTiming(anyMilestoneShowingCheckSV.value ? 1 : 0, { duration: 250 }),
      display: anyMilestoneShowingCheckSV.value ? 'flex' : 'none',
    };
  });

  const titleTextAnimatedStyle = useAnimatedStyle(() => {
    return {
      opacity: withTiming(anyMilestoneShowingCheckSV.value ? 0 : 1, { duration: 250 }),
      display: anyMilestoneShowingCheckSV.value ? 'none' : 'flex',
    };
  });

  return {
    titleTextAnimatedStyle,
    titleTextReachedAnimatedStyle,
    anyMilestoneShowingCheckSV,
    isSmallDesktop,
  };
};
